import { ApiUrls } from '@/data/superstack/ApiUrls';
import { api } from '@/src/utils/api';

const filtersUrl = ApiUrls().find((url) => url.name === 'jobs_filters').url;

const patchFilterNoti = (filterId, curVal) => {
  const filterUrl = `${filtersUrl}/${filterId}`;
  api.patch(filterUrl, {
    notification_enabled: !curVal,
  });
};

const deleteFilter = (filterId) => {
  const filterUrl = `${filtersUrl}/${filterId}`;
  api.delete(filterUrl);
};

export { patchFilterNoti, deleteFilter };
